var _style, _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000140000830326188122060000013239372036337685676_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,11V4h1v7H14z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 29,
    height: 29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18,6.736v1.109c2.389,1.262,4.023,3.77,4.023,6.655c0,4.148-3.375,7.523-7.523,7.523c-4.149,0-7.524-3.375-7.524-7.523 c0-2.885,1.634-5.393,4.024-6.655V6.736C8.042,8.075,5.976,11.048,5.976,14.5c0,4.7,3.824,8.523,8.524,8.523 s8.523-3.823,8.523-8.523C23.023,11.048,20.957,8.075,18,6.736z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.468d6977701bcc4f4d220d48c7d0e1f1.svg";
export { ForwardRef as ReactComponent };